// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"TipoServicioTable_spinnerContainer__1jlTd","botonAdd":"TipoServicioTable_botonAdd__TAqaD"};